var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M8.00008 9.41421L3.70718 13.7071L2.29297 12.2929L6.58586 8L2.29297 3.70711L3.70718 2.29289L8.00008 6.58579L12.293 2.29289L13.7072 3.70711L9.41429 8L13.7072 12.2929L12.293 13.7071L8.00008 9.41421Z"
  })));
}

export default SvgX;